const ViewIccConfig = ({ data }) => {
    const {
        appAid,
        clientId,
        clientSecret,
        localCode,
        piapEnvironmentPath,
        iccAppConfigurationId,
        aemEnvironment,
        iccEnvironment,
        redirectUrl,
        veevaConfigId,
        veevaInstanceType,
        aemHomePageUrl,
        aemErrorPagePath,
    } = data;

    return (
        <>
            <h5 className="mb-4">View ICC Config</h5>

            <div className="row">
                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Application ID</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{appAid}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Client ID</div>
                        <div className="col-md-8 d-flex text-break">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{clientId}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Client Secret</div>
                        <div className="col-md-8 d-flex text-break">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{clientSecret}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Local Code</div>
                        <div className="col-md-8 d-flex text-break">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{localCode}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">PIAP Environment Path</div>
                        <div className="col-md-8 d-flex text-break">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{piapEnvironmentPath}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">ICC Configuration ID</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{iccAppConfigurationId}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">AEM Environment Path</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{aemEnvironment}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">ICC Environment</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{iccEnvironment}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Redirect URL</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace text-break">{redirectUrl}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">
                            Veeva Environment Configuration ID
                        </div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{veevaConfigId}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">Veeva Instance Type</div>
                        <div className="col-md-8">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">
                                {veevaInstanceType.veevaInstanceType}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">AEM Home Page URL</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{aemHomePageUrl}</span>
                        </div>
                    </div>
                </div>

                <div className="col-md-6 mb-3">
                    <div className="row">
                        <div className="col-md-4 font-weight-bold">AEM Error Page Path</div>
                        <div className="col-md-8 d-flex">
                            <span className="d-inline-block mr-2">:</span>
                            <span className="text-monospace">{aemErrorPagePath}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewIccConfig;
